import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import './Input.css';

const Input = forwardRef(
    (
        {
            autoFocus,
            className,
            isDisabled,
            isInvalid,
            isReadOnly,
            isRequired,
            errorMsg,
            helperText,
            id,
            label,
            onChange,
            placeholder,
            rows,
            type,
            value,
            isRequiredBorder,
            onKeyPress,
            maxlength,
            name,
            autoComplete,
        },
        ref
    ) => {
        const showHelperText = helperText && (!isInvalid || !errorMsg);
        let inputClass = 'ab-input';
        let textAreaClass = 'ab-textarea';
        if (isRequiredBorder && isInvalid) {
            inputClass = 'ab-input ab-red-border';
            textAreaClass = 'ab-textarea ab-red-border';
        }
        return (
            <div className={`${className} ab-input-cnt`}>
                {label && (
                    <label
                        htmlFor={id}
                        data-disabled={isDisabled}
                        className="ab-input-label"
                        data-readonly={isReadOnly}
                    >
                        {label}
                        {isRequired && (
                            <span
                                className="ab-input-required-indicator"
                                role="presentation"
                                aria-hidden="true"
                            >
                                *
                            </span>
                        )}
                    </label>
                )}
                {type === 'textarea' ? (
                    <textarea
                        aria-disabled={isDisabled}
                        aria-invalid={isInvalid}
                        autoFocus={autoFocus}
                        className={textAreaClass}
                        disabled={isDisabled}
                        id={id}
                        type={type}
                        placeholder={placeholder}
                        readOnly={isReadOnly}
                        aria-readonly={isReadOnly}
                        value={value}
                        onChange={onChange}
                        ref={ref}
                        rows={4}
                        name={name}
                    />
                ) : (
                    <input
                        aria-invalid={isInvalid}
                        autoFocus={autoFocus}
                        className={inputClass}
                        disabled={isDisabled}
                        id={id}
                        type={type}
                        placeholder={placeholder}
                        readOnly={isReadOnly}
                        aria-readonly={isReadOnly}
                        value={value}
                        onChange={onChange}
                        ref={ref}
                        onKeyPress={onKeyPress}
                        maxLength={maxlength}
                        autoComplete={autoComplete}
                    />
                )}

                {showHelperText && (
                    <div className="ab-input-helper-text">{helperText}</div>
                )}

                {isInvalid && errorMsg && !isRequiredBorder && (
                    <div className="ab-input-error-msg">{errorMsg}</div>
                )}
            </div>
        );
    }
);

Input.defaultProps = {
    className: '',
};

Input.propTypes = {
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    isInvalid: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    isRequired: PropTypes.bool,
    isRequiredBorder: PropTypes.bool,
    errorMsg: PropTypes.string,
    helperText: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    onKeyPress: PropTypes.func,
    placeholder: PropTypes.string,
    rows: PropTypes.number,
    type: PropTypes.oneOf(['text', 'number', 'tel', 'email', 'textarea']),
    value: PropTypes.string,
    maxlength: PropTypes.string,
    name: PropTypes.string,
    autoComplete: PropTypes.string,
};

Input.displayName = 'Input';
export default Input;
